// extracted by mini-css-extract-plugin
export default {"header":"Header_header__MY7fH","username":"Header_username__z5bz2","logo":"Header_logo__qeTuP","title":"Header_title__6yJ+e","logoIcon":"Header_logoIcon__EWwMz"};